<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal"
    :width="modalWidth">


    <el-tabs v-model="activeTab" @tab-click="handleClick">

      <el-tab-pane :label="(mode=='Edit'||mode=='Create')?'':'New'" name="Edit">

        <fg-input label="Lead For">
          <el-select class="removeReadonly" v-model="incentifyerAccountId" filterable placeholder="Select">
            <el-option
              v-for="incentifyer in $store.getters.incentifyers"
              :key="incentifyer.id"
              :label="incentifyer.profile ? incentifyer.profile.companyName || '-' : '-' "
              :value="incentifyer.id">
            </el-option>
          </el-select>
        </fg-input>

        <fg-input type="text"
                  label="Business Name"
                  placeholder="Name"
                  required
                  v-model="name"/>

        <fg-input type="text"
                  label="Main Contact Name"
                  placeholder="Name"
                  required
                  v-model="mainContactName"/>

        <fg-input type="text"
                  label="Main Contact Email"
                  placeholder="Email"
                  required
                  v-model="mainContactEmail"/>

        <!-- <fg-input label="Status">
            <Lead-Status-Input :lead="lead"/>
        </fg-input> -->

        <fg-input label="Notes"
                  required>
          <el-input type="textarea"
                    :autosize="{minRows: 2}"
                    placeholder="Notes"
                  required
                    v-model="notes"/>
        </fg-input>
        
        <l-checkbox v-model="hot">Hot Lead</l-checkbox>
      </el-tab-pane>


      <el-tab-pane v-if="showReceivedTab" label="Received" name="Received">
        <Leads-Table modal noRowClick :filter="$store.getters.Lead._status.RECEIVED"/>
      </el-tab-pane>

    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
      <button class="btn btn-success" @click="confirm()">{{buttonLabel}}</button>
    </span>
  </el-dialog>
</template>

<script>
import { Lead } from 'src/classes/datamodel.js'
export default {
  name: 'Lead-Modal',
  data () {
    return {
      selectedTab: '',
      closing: false // without this, the tab changes every time the modal is opened in Close/Lost mode
    }
  },
  computed: {
    mode () {
      return this.$store.getters.modal.mode
    },
    title () {
      return this.mode + ' Lead' // ADD 's' when multiple leads selected
    },
    visible () {
      return this.$store.getters.modal.current == 'Lead'
    },
    lead () {
      //let useless = this.$store.getters.modal.object
      //console.log('lead(): ', this.$store.getters.modal.object.constructor.name)
      if (typeof this.$store.getters.modal.object == 'object' && this.$store.getters.modal.object.constructor.name == 'Lead') { // TODO: does this work when minimized??
        return this.$store.getters.modal.object
      }
      else {
        return new Lead({ status: Lead._status.RECEIVED.value,
                          // affiliateId: this.$store.getters.affiliateUser.id
                           })
      }
    },
    buttonLabel () {
      switch (this.mode) {
        case 'Create':
          return 'Create'
        case 'Edit':
          return 'Save'
        case 'Close':
          return this.activeTab == 'Edit' ? 'Save' : 'Close Leads'
        case 'Lost':
          return this.activeTab == 'Edit' ? 'Save' : 'Lost Leads'
        default:
          return 'Save'
      }
    },
    activeTab: { // TODO (?): WHEN CLOSING MODAL, MESSES UP THE ACTIVATE TAB FOR NEXT OPEN_MODAL
      get () {
        if (this.selectedTab) {
          return this.selectedTab
        }
        else {
          return this.showReceivedTab ? 'Received' : 'Edit'
        }
      },
      set (tab) {
        if (!this.closing) {
          this.selectedTab = tab
        }
      }
    },
    showReceivedTab () {
      // console.log('showReceivedTab(): ')
      console.log(this.mode)
      console.log(this.affiliateId)
      if (this.mode == 'Close' || this.mode == 'Lost') {
        let leads = this.$store.getters.leadsJson.filter(lead => lead.status == Lead._status.RECEIVED.value)
        console.log(leads)
        if (this.affiliateId) {
          leads = leads.filter(lead => lead.affiliateId == this.affiliateId)
          console.log(leads)
        }
        return leads.length > 0
      }
      else {
        return false
      }
    },
    // affiliateId: {
    //   get ()    { return  this.lead.affiliateId },
    //   set (affiliateId) { this.lead.affiliateId = affiliateId}
    // },
    name: {
      get () { return  this.lead.name },
      set (name)     { this.lead.name = name}
    },
    mainContactName: {
      get ()        { return  this.lead.mainContactName },
      set (mainContactName) { this.lead.mainContactName = mainContactName}
    },
    mainContactEmail: {
      get ()         { return  this.lead.mainContactEmail },
      set (mainContactEmail) { this.lead.mainContactEmail = mainContactEmail}
    },
    notes: {
      get () { return  this.lead.notes },
      set (notes)    { this.lead.notes = notes}
    },
    hot: {
      get () { return this.lead.hot },
      set (hot)     { this.lead.hot = hot}
    },
    incentifyerAccountId: {
      get ()    { return this.lead.incentifyerAccountId },
      set (id)         { this.lead.incentifyerAccountId = id }
    },
    modalWidth () {
      return window.innerWidth
    }
  },
  methods: {
    closeModal () {
      this.closing = true
      if (this.$store.getters.selectedObjects != null) {
        this.$store.commit('STOP_SELECT_OBJECTS')
      }
      
      this.$store.dispatch('closeModal').then(function() {
        if (this) {
          this.closing = false
          this.selectedTab = ''
        }
      })
    },
    async confirm () {
      let action = ''
      let obj = null
      switch (this.mode) {
        case 'Create':
          action = 'submitLead'
          obj = new Lead(this.lead)
          break
        // case 'Edit':
        //   action = 'updateRestObject'
        //   obj = new Lead(this.lead)
        //   break
        // case 'Close':
        //   action = 'closeLeads'
        //   break
        // case 'Lost':
        //   action = 'lostLeads'
        //   break
        default:
          console.log('LeadModal>confirm(): unplanned mode')
          break
      }
      
      const res = await this.$store.dispatch(action, obj)
      const errorMessage = !res || (res && res.errors  && res.errors.length > 0) ? res.errors.toString() : 'Error'
      if (!res || res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) {
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else {
        this.$notify({ successMessage: 'Submitted!'})
        this.closeModal()
        this.$store.dispatch('fetchData')
      }
    },
    handleClick () {}
  }
}
</script>

<style>

</style>